import React from "react";
import { withTranslation } from "react-i18next";
import { FollowupNewRecruiterView } from "../../views";
import { socket } from "../../../Context";
import {
  LocalStorageService,
  ClientCompanyService,
  WorkflowService,
  ContractorService,
  ClientContractService,
  WorkflowMessagesService,
  RepseService
} from "../../../services/index";
import moment from "moment";
import "moment/locale/es";
import { convertToStandarDate, getNavigatorTimezone } from "../../../utils";

class FollowUpNewRecruiterAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      contractorClientDocuments: [],
      contract: {},
      message: " ",
      token: "",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      idContractor: "",
      statusWorkflow: "",
      documents: [],
      workflowExecutionId: "",
      usersChat: {},
      membersChat: [],
      conversation: [],
      dataItemMessages: {},
      messageChat: {},
      registerDate: "",
      contractor: {}
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  clientCompanyService = new ClientCompanyService(this.url);
  workflowService = new WorkflowService(this.url);
  contractorService = new ContractorService(this.url);
  clientContractService = new ClientContractService(this.url);
  workflowMessagesService = new WorkflowMessagesService(this.url);
  repseService = new RepseService(this.url)

  workflowExecutionId = "";
  clientContractId = "";
  idAuthorMessage = 0;
  timezone = getNavigatorTimezone()

  async componentDidMount() {
    try {
      this.setState({ loading: true });
      this.token =
        this.localStorageService.getLocalStorageItem("token").idToken;
      this.user = this.localStorageService.getLocalStorageItem("user");

      //Get id from url
      let urlArr = window.location.href.split("/");
      this.workflowExecutionId = urlArr[urlArr.length - 1];
      this.clientContractId = urlArr[urlArr.length - 2];

      let workflowExecutionId = this.workflowExecutionId;
      let contractId = this.clientContractId;

      //call sockets      
      socket.on("messages", (data) => this.addNewMessageSocket(data));
      socket.emit("joinRoom", this.workflowExecutionId)

      //Get workflows information
      let workflowExecution =
        await this.workflowService.getWorkFlowExecutionById(
          workflowExecutionId,
          this.token
        );
      //Get contracts information
      let contractorClientDocument =
        await this.contractorService.getContractorClientDocuments(
          Number(contractId),
          this.token
        );

      //Get message and members chat
      let workflowMessage =
        await this.workflowMessagesService.getWorkFlowExecutionMessage(
          this.workflowExecutionId,
          this.timezone,
          this.token
        );

      let user = {};
      //users chat

      //Filter out duplicated members
      let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
        workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
      );

      membersChat.map((member) => {
        member.id = member.workflowExecutionMemberId;
        member.avatarUrl = member.profilePicture;
        member.name = member.firstName + " " + member.firstLastName;
        member.avatarAltText = member.firstName + " " + member.firstLastName;
        if (this.user.userMetaData.userA3Cloud.email === member.email) {
          this.idAuthorMessage = member.id;
          user = member;
        }
        return membersChat;
      });
      //Message chat
      workflowMessage.data.workflowExecutionMessages.map((member) => {
        member.author = {
          name: member.firstName + " " + member.firstLastName,
          id: member.workflowExecutionMemberId,
          avatarUrl: member.profilePicture,
        };
        member.timestamp = new Date(member.createdDate);
        member.text = member.workflowExecutionMemberMessage;
        member.id = member.workflowExecutionMemberId;
        member.name = member.firstName + " " + member.firstLastName;
        member.avatarUrl = member.profilePicture;
        if (member.workflowExecutionMemberMessageDoc.length > 0) {
          member.attachments = [
            {
              name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
              site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
            },
          ];
        }
        return workflowMessage.data.workflowExecutionMessages;
      });

      let contractorClientContract =
        await this.contractorService.getContarctorByEmailAndClientId(
          Number(contractId),
          this.token
        );

      //Register date from contract
      let preferredLanguage = this.localStorageService.getLocalStorageItem("preferredLanguage")
      let language = preferredLanguage || "es"
      this.state.registerDate = convertToStandarDate(contractorClientContract.contractor.createdDate, language)

      const documentsRegister = contractorClientDocument.data.data.filter(
        (docRegister) => docRegister.documentWasLoaded !== false
      );

      documentsRegister.map((contract) => {
        contract.documentName = contract.clientDocument.name;
        contract.registerDate = contract.createdDate
        contract.textSubtitle = this.props.t("contractingRegistrationDataView.grid.registeredThe");
        return documentsRegister;
      });

      this.setState({
        token: this.token,
        loading: false,
        contract: contractorClientContract.contractor,
        registerDate: this.state.registerDate,
        documents: documentsRegister,
        workflowButtons: workflowExecution.data.workflowStatusDescriptions,
        buttonBack:
          workflowExecution.data.workflowStatusDescriptions.statusBack.name,
        buttonNext:
          workflowExecution.data.workflowStatusDescriptions.statusNext.name,
        titleHeader:
          workflowExecution.data.workflowStatusDescriptions.statusCurrent.name,
        workflowExecutionId: workflowExecutionId,
        idContractor: Number(contractId),
        statusWorkflow:
          workflowExecution.data.workflowStatusDescriptions.statusCurrent,
        membersChat: membersChat,
        conversation: workflowMessage.data.workflowExecutionMessages,
        usersChat: user,
        token: this.token,
        contractor: contractorClientContract.contractor
      });
    } catch (error) {
      this.props.history.push("/");
      this.setState({
        loading: false,
        token: this.token,
      });
    }
  }

  async componentWillUnmount() {
    socket.emit("leaveRoom", this.workflowExecutionId)
  }


  //Function to create message
  createMessage = async (messagesChat, fileContent) => {
    let data = new FormData();
    data.append("workflowExecutionId", this.workflowExecutionId);
    data.append("workflowExecutionMemberId", this.idAuthorMessage);
    data.append("message", messagesChat.text);
    data.append("documento", fileContent);
    data.append("timezone", this.timezone)

    if (messagesChat.usersMentioned && messagesChat.usersMentioned.length > 0) {
      data.append('usersMentioned', JSON.stringify(messagesChat.usersMentioned))
    }

    await this.workflowMessagesService.createWorkflowExecutionNewMessage(
      data,
      this.token
    );
  };

  markChatAsRead = async () => {
    try {
      await this.workflowMessagesService.markAsRead(this.workflowExecutionId, this.token)
    } catch (e) { }
  };

  //Function loading dialog
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  //Function complete dialog
  toggleCompletedRequesting = (value, message, clientCompany) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            clientCompany: clientCompany,
          });
        }, 8000);
      }
    );
  };

  //Function error dialog
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false, message: "" });
        }, 5000);
      }
    );
  };

  handleBtnGo = async () => {
    this.props.history.push("/");
  };

  //buttons status
  backBtn = async () => {
    this.toggleLoadingRequesting(true);
    let workflowExecutionActionId = 4; //change status workflow to back status
    let workflowChange = await this.workflowService.changeStatusWorkflow(
      this.state.workflowExecutionId,
      workflowExecutionActionId,
      this.token
    );
    if (
      workflowChange &&
      workflowChange.data &&
      Number(workflowChange.statusCode) === 200
    ) {
      let url = `contractor-registration/${this.state.idContractor}`;
      let updateUrl = await this.workflowService.updateSolicitudeUrlInbox(
        url,
        this.state.idContractor,
        this.token
      );
      if (updateUrl && updateUrl.data && Number(updateUrl.statusCode) === 200) {
        this.toggleLoadingRequesting(false);
        this.toggleCompletedRequesting(true);
        setTimeout(() => {
          this.toggleCompletedRequesting(false);
          this.props.history.push("/");
        }, 3000);
      } else {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
      }
    } else {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
      setTimeout(() => {
        this.toggleErrorRequesting(false);
      }, 3000);
    }
  };

  nextBtn = async () => {
    this.toggleLoadingRequesting(true);
    if (
      [Number(process.env.REACT_APP_STATUS_CONTRACTOR_101220), Number(process.env.REACT_APP_STATUS_CONTRACTOR_101215)].includes(Number(this.state.statusWorkflow.status)) &&
      !this.state.contractor.isRepse
    ) {
      let updateContract =
        await this.contractorService.secondValidationContractor(
          this.state.workflowExecutionId,
          this.state.idContractor,
          this.token
        );
      if (
        !updateContract ||
        !updateContract.data ||
        Number(updateContract.statusCode) !== 200
      ) {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true, "Could not update contract status");
        setTimeout(() => {
          this.toggleErrorRequesting(false);
        }, 3000);
        return;
      }
    }

    //Esta validacion ya no va por que la relacion CompanyContractor se hace al crear al contratante
    // if (
    //   [Number(process.env.REACT_APP_STATUS_CONTRACTOR_101220), Number(process.env.REACT_APP_STATUS_CONTRACTOR_101215)].includes(Number(this.state.statusWorkflow.status)) &&
    //   this.state.contractor.isRepse
    // ) {
    //   let companyContractor = await this.repseService.createRelationCompanyContractor(this.state.idContractor, process.env.REACT_APP_ID_COMPANY_REPSE, this.token)
    //   if (!companyContractor || !companyContractor.data || Number(companyContractor.statusCode) !== 200) {
    //     this.toggleLoadingRequesting(false);
    //     this.toggleErrorRequesting(true, "Could not relate contractor to company");
    //     setTimeout(() => {
    //       this.toggleErrorRequesting(false);
    //     }, 3000);
    //     return;
    //   }
    // }

    let workflowExecutionActionId = 3; //change status workflow to back status
    let workflowChange = await this.workflowService.changeStatusWorkflow(
      this.state.workflowExecutionId,
      workflowExecutionActionId,
      this.token
    );
    if (
      workflowChange &&
      workflowChange.data &&
      Number(workflowChange.statusCode) === 200
    ) {
      this.toggleLoadingRequesting(false);
      this.toggleCompletedRequesting(true);
      setTimeout(() => {
        this.toggleCompletedRequesting(false);
        this.props.history.push("/");
      }, 3000);
    } else {
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
      setTimeout(() => {
        this.toggleErrorRequesting(false);
      }, 3000);
    }
  };

  //add a new meessage to conversation when sockets send a mew message
  addNewMessageSocket = (message) => {
    let copyConversation = [...this.state.conversation];
    let indexMessage = copyConversation.length;

    let newMessage = {
      author: {
        name: `${message.firstName} ${message.firstLastName}`,
        id: Number(message.workflowExecutionMemberId),
        avatarUrl: message.profilePicture,
      },
      timestamp: message.workflowExcecutionMemberMessage
        ? new Date(message.workflowExcecutionMemberMessage.createdDate)
        : new Date(
          message.workflowExecutionMemberMessageDocName[0].createdDate
        ),
      text: message.workflowExcecutionMemberMessage.message,
      id: Number(message.workflowExecutionMemberId),
      name: `${message.firstName} ${message.firstLastName}`,
      avatarUrl: message.profilePicture,
      workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
      workflowExecutionMemberMessage:
        message.workflowExcecutionMemberMessage.message === "" ||
          message.workflowExcecutionMemberMessage.message === "undefined"
          ? null
          : message.workflowExcecutionMemberMessage.message,

      email: message.email,
      firstName: message.firstName,
      firstLastName: message.firstLastName,
      profilePicture: message.profilePicture,
      selectionIndex: indexMessage,
    };
    if (message.workflowExecutionMemberMessageDocName.length > 0) {
      newMessage.workflowExecutionMemberMessageDoc = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
      newMessage.attachments = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
    }

    copyConversation.push(newMessage);
    this.setState({
      conversation: copyConversation,
    });
  };

  render() {
    return (
      <FollowupNewRecruiterView
        {...this.state}
        {...this.props}
        nextBtn={this.nextBtn}
        backBtn={this.backBtn}
        handleBtnGo={this.handleBtnGo}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        createMessage={this.createMessage}
        markChatAsRead={this.markChatAsRead}
      />
    );
  }
}

export default withTranslation()(FollowUpNewRecruiterAction);
